// extracted by mini-css-extract-plugin
module.exports = {"root":"Cooperate_root__3SutH","containerWrapper":"Cooperate_containerWrapper__xFtSw"};